<div class="configure-telephone-wrapper">

  <div class="dialog-header" *ngIf="!isGroup">
    <div class="header-title-wrapper px-8 mb-8 justify-between">
      <div class="flex">

        <i class="fal fa-chevron-left text-white text-2xl cursor-pointer" (click)="closeConfiguration()"></i>
        <p *ngIf="!isProfile" class="text-white text-2xl ml-4">Configurar línea telefónica: <span
            class="text-accent">{{telephone}}</span>
          <span><i *ngIf="pendingInQueue>0" class="fal fa-circle-exclamation"
              [matTooltip]="'Esta línea tiene '+ pendingInQueue +' configuraciones pendientes'"></i></span>
        </p>
        <p *ngIf="isProfile && profile" class="text-white text-2xl ml-4">Configurar perfil: <span
            class="text-accent">{{profile.name || 'Nuevo perfil'}}</span>
          <span><i *ngIf="pendingInQueue>0" class="fal fa-circle-exclamation"
              [matTooltip]="'Esta línea tiene '+ pendingInQueue +' configuraciones pendientes'"></i></span>
        </p>
        <p *ngIf="isProfile && !profile" class="text-white text-2xl ml-4">Configurar perfil
      </p>
      </div>
      <div>
        <app-accent-button (click)="saveChanges()" text="Guardar cambios" [selected]="true"></app-accent-button>
      </div>
    </div>
  </div>
  <div class="w-56 m-2 ml-auto mt-0" *ngIf="isGroup">
    <app-accent-button (click)="saveChanges()" text="Guardar configuración" [selected]="true"></app-accent-button>
  </div>
  <div class="w-full h-[1px] bg-tertiary"></div>
  <div class="flex px-8 my-4 gap-2" [style]="loadingApi == true ? 'pointer-events: none; opacity: 0.5;' : ''">
    <app-accent-button text="Llamadas/SMS" [selected]="currentTab=='calls'"
      (click)="changeTab('calls')"></app-accent-button>
    <app-accent-button text="Desvíos" [selected]="currentTab=='forwarding'"
      (click)="changeTab('forwarding')"></app-accent-button>
    <app-accent-button text="Datos/internet" [selected]="currentTab=='internet'"
      (click)="changeTab('internet')"></app-accent-button>
    <app-accent-button text="Reglas" [selected]="currentTab=='rules'" (click)="changeTab('rules')"></app-accent-button>
    <app-accent-button *ngIf="!isProfile && !isGroup" text="Blacklist" [selected]="currentTab=='blacklist'"
      (click)="changeTab('blacklist')"></app-accent-button>
    <app-accent-button *ngIf="!isProfile && !isGroup" text="Whitelist" [selected]="currentTab=='whitelist'"
      (click)="changeTab('whitelist')"></app-accent-button>
    <app-accent-button *ngIf="!isProfile && !isGroup" text="Gestión de consumo" [selected]="currentTab=='consumo'"
      (click)="changeTab('consumo')"></app-accent-button>
      <app-accent-button *ngIf="!isProfile && !isGroup" text="Redirecciones" [selected]="currentTab=='redir'"
      (click)="changeTab('redir')"></app-accent-button>
    <app-accent-button *ngIf="!isProfile && !isGroup" text="Extra" [selected]="currentTab=='extra'"
      (click)="changeTab('extra')"></app-accent-button>
    <app-accent-button *ngIf="!isProfile && !isGroup" text="SIM" [selected]="currentTab=='sim'"
      (click)="changeTab('sim')"></app-accent-button>
  </div>

  <div class="options-wrapper" *ngIf="!loadingApi">
    <div *ngFor="let item of settings; let i = index">
      <div class="line" *ngIf="displayedSettings.includes(item.featureID)">

        <div class="flex items-center w-full config-line-resp" style="gap: 12px;">
          <p class="w-2/4"
            *ngIf="item.featureID!='AireBarrado70X' && item.featureID!='AireBarrado_m2m' && item.featureID!='IMEI'">
            {{item.servicio}}</p>
          <p class="w-2/4" *ngIf="item.featureID=='AireBarrado70X'">Bloqueo Llamadas Salientes 70X</p>
          <p class="w-2/4" *ngIf="item.featureID=='AireBarrado_m2m'">Bloqueo Llamadas Salientes m2m</p>
          <p class="w-2/4" *ngIf="item.featureID=='IMEI'">IMEI</p>
          <mat-slide-toggle *ngIf="withActive.includes(item.featureID)" [checked]="item.active=='true'"
            (change)="changeActive(i)"></mat-slide-toggle>


          <div class="custom-select flex justify-end items-center w-full" style="gap: 12px;"
            *ngIf="withSelectPhone.includes(item.featureID) && item.active=='true'">
            <div style="min-width: 205px; position: relative; gap: 10px;" class="flex flex-col">
              <i class=" far fa-chevron-down icon"></i>
              <mat-select [placeholder]="'Elegir'"
                [value]="(item.extString=='121' || item.extString=='34121' || item.extString=='34602209999' ||  item.extString==null) ? item.extString : ''"
                (valueChange)="extStringChange(i, $event)">
                <mat-option value="121">121: Buzón</mat-option>
                <mat-option value="34121">34121:
                  Buzón</mat-option>
                <mat-option value="34602209999">Aviso
                  SMS</mat-option>
                <mat-option value="">Otro teléfono</mat-option>
              </mat-select>
              <input [id]="'input-'+item.featureID" type="number" placeholder="Introduce número"
                [value]="item.extString"
                [style]="(item.extString!='121' && item.extString!='34121' && item.extString!='34602209999' && item.extString!=null) ? 'display: block;' : 'display: none; '"
                (change)="extStringChangeInput(i, $event)" [class]="item.extString==''? 'input-error' : ''">
            </div>

          </div>

          <div class="custom-select" *ngIf="withSelectRoaming.includes(item.featureID) && item.active=='true'">
            <i class="far fa-chevron-down icon"></i>
            <mat-select [placeholder]="'Elegir'" [value]="item.extString" (valueChange)="extStringChange(i, $event)">
              <mat-option *ngIf="item.featureID=='RoamingOutsidePLMN-CountryBarred'" value="RoamZ1CS">Activa Zona
                1</mat-option>
              <mat-option *ngIf="item.featureID=='RoamingOutsidePLMN-CountryBarred'" value="RoamZ3CS">Activa Zona 1, 2 y
                3</mat-option>
              <mat-option *ngIf="item.featureID=='RoamerAccessToHPLMN-AP-Barred'" value="RoamZ1PS">Activa Zona
                1</mat-option>
              <mat-option *ngIf="item.featureID=='RoamerAccessToHPLMN-AP-Barred'" value="RoamZ3PS">Activa Zona 1, 2 y
                3</mat-option>
            </mat-select>
          </div>

          <div class="custom-select flex flex-col" style="gap: 12px;"
            *ngIf="withSelectTime.includes(item.featureID) && item.active=='true'">
            <i class="far fa-chevron-down icon"></i>
            <mat-select [placeholder]="'Elegir'" (valueChange)="extNumberChange(i, $event)" [value]="item.extNumber">
              <mat-option value="5">5 segundos</mat-option>
              <mat-option value="10">10 segundos</mat-option>
              <mat-option value="15">15 segundos</mat-option>
              <mat-option value="20">20 segundos</mat-option>
              <mat-option value="25">25 segundos</mat-option>
              <mat-option value="30">30 segundos</mat-option>
              <mat-option value="35">35 segundos</mat-option>
              <mat-option value="40">40 segundos</mat-option>
              <mat-option value="45">45 segundos</mat-option>
            </mat-select>
            <input [id]="'input-'+item.featureID" type="number" placeholder="Introduce número" [value]="item.extString"
              *ngIf="withInput.includes(item.featureID) && item.active=='true' && item.featureID=='Cfnry'"
              (change)="extStringChangeInput(i, $event)" [class]="item.extString==''? 'input-error' : ''">
          </div>

          <div class="custom-select" *ngIf="withSelectShow.includes(item.featureID) && item.active=='true'">
            <i class="far fa-chevron-down icon"></i>
            <mat-select [placeholder]="'Elegir'" (valueChange)="extNumberChange(i, $event)" [value]="item.extNumber">
              <mat-option value="1">Ocultar</mat-option>
              <mat-option value="2">Mostrar</mat-option>
            </mat-select>
          </div>

          <input [id]="'input-'+item.featureID" type="number" placeholder="Introduce número" [value]="item.extString"
            *ngIf="withInput.includes(item.featureID) && item.active=='true' && item.featureID!='Cfnry'"
            (change)="extStringChangeInput(i, $event)" [class]="item.extString==''? 'input-error' : ''">

          <!-- <input [id]="'input-'+item.featureID" type="text" placeholder="Introduce número" [value]="item.extString"
            *ngIf="item.featureID=='IMEI'" (change)="extStringChangeInput(i, $event)"> -->
            <p *ngIf="item.featureID=='IMEI'">{{ item.extString }}</p>

          <div *ngIf="item.featureID=='LastUpdateLocation'">
            <input matInput [matDatepicker]="picker" (click)="picker.open()" readonly style="cursor: pointer;"
              [formControl]="date">
            <mat-datepicker #picker></mat-datepicker>
          </div>

          <div *ngIf="item.featureID=='VLR'" class="flex justify-end items-center double-input" style="gap: 12px;">
            <input type="text" placeholder="País" (change)="countryChange(i, $event)" [value]="item.country">
            <input type="text" placeholder="Nombre de red" (change)="networkChange(i, $event)"
              [value]="item.network_name">
          </div>
        </div>
      </div>
    </div>

    <div [style]="currentTab=='rules' ? 'display:block' : 'display: none'">
      <p *ngIf="associatedIp=='' && !loading" class="no-ip-text">Esta línea no tiene ninguna IP asociada</p>
      <div *ngIf="associatedIp!=''">
        <div style="flex: 1 1 auto; overflow-y: auto;">
          <app-rules-editor mode="line" [ip]="associatedIp" (deleteRuleEvent)="deleteRule($event)"
            (resetRule)="resetRule()"></app-rules-editor>
        </div>
      </div>
    </div>

    <div *ngIf="currentTab=='whitelist'">
      <div class="flex items-center justify-between white-black-list">
        <p class="title">Añadir número a la whitelist <span><i class="fal fa-circle-info"
              matTooltip="De haber algún número en la whitelist, esta línea solo permitirá llamadas de dichos números"></i></span>
        </p>
        <div class="flex items-center justify-end relative" style="gap: 12px;">
          <p *ngIf="errorBlackWhitelist==true" class="white-black-list-error-msg">El número ya está en la lista</p>
          <input type="number" id="whitelist-input" (input)="errorBlackWhitelist=false"
            [class]="errorBlackWhitelist==true ? 'error' : ''">
          <app-accent-button text="Añadir" [selected]="true" (click)="addToWhitelist()"></app-accent-button>
        </div>
      </div>
      <div class="line black-white-list-line" *ngFor="let phone of whitelist">
        <p>{{phone}}</p>
        <i class="fal fa-times" (click)="deleteFromWhitelist(phone)"></i>
      </div>
    </div>

    <div *ngIf="currentTab=='blacklist'">
      <div class="flex items-center justify-between white-black-list">
        <p class="title">Añadir número a la blacklist <span><i class="fal fa-circle-info"
              matTooltip="Esta línea no permitirá llamadas de ningún número que se encuentre en la blacklist"></i></span>
        </p>
        <div class="flex items-center justify-end relative" style="gap: 12px;">
          <p *ngIf="errorBlackWhitelist==true" class="white-black-list-error-msg">El número ya está en la lista</p>
          <input type="number" id="blacklist-input" [class]="errorBlackWhitelist==true ? 'error' : ''">
          <app-accent-button text="Añadir" [selected]="true" (click)="addToBlacklist()"></app-accent-button>
        </div>
      </div>
      <div class="line black-white-list-line" *ngFor="let phone of blacklist">
        <p>{{phone}}</p>
        <i class="fal fa-times" (click)="deleteFromBlacklist(phone)"></i>
      </div>
    </div>

    <div *ngIf="currentTab=='consumo'">
      <div class="line">
        <div class="flex items-center w-full config-line-resp">

          <p class="text-white w-2/4">Opciones de consumo</p>
          <div class="custom-select">
            <i class="far fa-chevron-down icon"></i>
            <mat-select [placeholder]="'Elegir'" [(value)]="selectedConsumption" [value]="selectedConsumption"
              (valueChange)="changeOption($event)">
              <mat-option *ngFor="let cons of consumption" [value]="cons">{{cons.name}}</mat-option>
            </mat-select>
          </div>
        </div>

      </div>
      <div class="line">
        <div class="flex items-center w-full config-line-resp">

          <p class="text-white w-2/4">Notificación:</p>
          <div class="flex justify-center">
            <p class="flex items-center mx-4 min-h-[35px]">
              SMS
              <input class="w-4 h-4 mx-2" type="checkbox" [value]="true" [(ngModel)]="smsNotification"
                (change)="changeNotification($event)">
            </p>
            <p class="flex items-center mx-4 min-h-[35px]">Email
              <input class="w-4 h-4  mx-2" type="checkbox" [value]="true" [(ngModel)]="emailNotification"
                (change)="changeNotification($event)">
            </p>
            <input type="text" placeholder="Introduce email" *ngIf="emailNotification" [(ngModel)]="userEmail">
          </div>

        </div>

      </div>

    </div>

    <div *ngIf="currentTab=='redir'">
      <div class="line">
        <div class="flex items-center w-full config-line-resp">

          <p class="text-white w-2/4">Redirección a </p>
          <input class="" type="tel" [(ngModel)]="redirectionNumber">

        </div>
      </div>
      <div class="line">
        <div class="flex items-center w-full config-line-resp">

          <p class="text-white w-2/4">Número entrante</p>
          <input class="" id="redirection-input" type="tel" [(ngModel)]="originNumber">
          <app-accent-button text="Añadir" [selected]="true" (click)="addToRedirection()"></app-accent-button>
        </div>
      </div>

      <div class="line black-white-list-line" *ngFor="let phone of redirectionList">
        <p>Número entrante:  <span class="text-accent">{{phone.origin_number}}</span></p>
        <p>Redirección a:  <span class="text-accent">{{phone.redirect_number}}</span></p>
        <i class="fal fa-times" (click)="deleteFromRedirection(phone)"></i>
      </div>
    </div>


    <div *ngIf="currentTab=='extra'">
      <div class="line">
        <div class="flex items-center w-full config-line-resp">

          <p class="text-white w-2/4">Minutos mensuales</p>
          <input class="" type="text" [(ngModel)]="monthlyMinutes">

        </div>
      </div>
      <div class="line">
        <div class="flex items-center w-full config-line-resp">
      
          <p class="text-white w-2/4">Gigas mensuales</p>
          <input class="" type="text" [(ngModel)]="monthlyData">
      
        </div>
      </div>

      <app-rules-editor mode="line" [isEdit]="true" [extra]="true" [rulesData]="rulesData" (linesRules)="getRules($event)"></app-rules-editor>

    </div>

    <div *ngIf="currentTab=='sim'">
      <div class="line">
        <div class="flex items-center w-full config-line-resp">

          <p class="text-white w-2/4">Asignar SIM</p>
          <input class="" type="text" [(ngModel)]="selectedSim">
          <!-- <div class="custom-select w-1/6">
            <i class="far fa-chevron-down icon"></i>
            <mat-select [(ngModel)]="selectedSim" (ngModelChange)="changeSim($event)">
              <mat-option [value]="lineSim">{{ lineSim.icc }}</mat-option>
              <mat-option *ngFor="let sim of sims" [value]="sim">{{ sim.icc }}</mat-option>
            </mat-select>
          </div> -->
          
          
        </div>

      </div>
      <!-- <div class="line">
        <div class="flex items-center w-full config-line-resp">
          <p class="text-white w-2/4">Bloquear SIM</p>
          <mat-slide-toggle [checked]="isBlocked" (change)="checkSim($event)"></mat-slide-toggle>

        </div>

      </div> -->

    </div>
  </div>

  <div *ngIf="loadingApi==true" class="loading-wrapper" style="flex: 1 1 auto;">
    <mat-spinner></mat-spinner>
    <p>Cargando...</p>
  </div>

</div>




<!-- 
<div class="dialog-footer"
  [ngClass]="loadingApi==true || settings[26].extString=='' || settings[27].extString=='' || settings[28].extString=='' || settings[29].extString=='' || !checkRuleValid()? 'disabled' : ''">
  <div class="apply-many-button" (click)="openAddToMore()">
    <span class="text">Aplicar a varias líneas</span>
  </div>

</div> -->